import { Pencil, Trash2 } from 'lucide-react';

import { ProtectedComponent } from '@/components/ProtectedComponent';
import { DropdownAction } from '@/components/ui/dropdown-actions';
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

import { useToggle } from '@/hooks/use-toggle';

import { Permissions } from '@/constants';

import { DeletePhoneNumber } from './delete-phone-number';
import { UpdatePhoneNumber } from './update-phone-number';

import type { PhoneNumberConfiguration } from '@/types/phone-number.type';

export const RowAction = ({ phoneNumber }: { phoneNumber: PhoneNumberConfiguration }) => {
  const { state: deletePhoneNumberState, toggle: togglePhoneNumber } = useToggle();
  const { state: updatePhoneNumberState, toggle: toggleUpdatePhoneNumber } = useToggle();

  return (
    <>
      <ProtectedComponent
        requiredPermissions={[Permissions.PhoneNumberCreateUpdate, Permissions.PhoneNumberDelete]}
      >
        <DropdownAction>
          <ProtectedComponent requiredPermissions={[Permissions.PhoneNumberCreateUpdate]}>
            <DropdownMenuItem onClick={toggleUpdatePhoneNumber}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          </ProtectedComponent>

          <DropdownMenuSeparator />
          <ProtectedComponent requiredPermissions={[Permissions.PhoneNumberDelete]}>
            <DropdownMenuItem
              variant="destructive"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                togglePhoneNumber();
              }}
            >
              <Trash2 className="h-4 w-4" />
              Delete
            </DropdownMenuItem>
          </ProtectedComponent>
        </DropdownAction>
      </ProtectedComponent>

      {deletePhoneNumberState && (
        <DeletePhoneNumber phoneNumber={phoneNumber} toggle={togglePhoneNumber} />
      )}

      {updatePhoneNumberState && (
        <UpdatePhoneNumber phoneNumber={phoneNumber} toggle={toggleUpdatePhoneNumber} />
      )}
    </>
  );
};
